import { Box, Checkbox, FormControlLabel, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DialogsContext } from "../contexts";
import TermForm from "./term.form";
import { termApi } from "./term.queries";
import { termSchema } from "./term.schema";

export default function TermDialog(props) {
	const navigate = useNavigate();
	const useSave = termApi.useSave();
	const useDelete = termApi.useDelete();

	const { dialogs } = useContext(DialogsContext);
	const [addMore, setAddMore] = useState(false);

	const [term, setTerm] = useState(props.term);
	useEffect(() => {
		setTerm(props.term);
	}, [props.term]);

	const save = async () => {
		dialogs.saving('term');
		let result = await useSave.mutateAsync(term);
		// _.assign(result, term);
		if (addMore) {
			setTerm({});
		}
		else{
			if (!term.skipRedirect && !term?.id && result?.id) {
				navigate('/terms/' + result.id);
			}
			else {
				props?.onSubmit?.(result);
			}
			dialogs.close();
		}
		dialogs.saved('term');
	}

	const onDelete = async () => {
		await useDelete.mutateAsync(term.id);
		props?.onDelete?.(term);
		dialogs.close();
	}

	return (
		<Dialog onClose={props.onCancel} open={props.open}>
			<DialogTitle>{term?.id ? 'Edit' : 'Add'} Term</DialogTitle>
			<DialogContent>
				<Stack spacing={4}>
					<TermForm term={term} onChange={(term) => setTerm(term)} sx={{ minWidth: 200 }} />
					{/* <Divider orientation="vertical" flexItem />
					<Stack direction="column" sx={{ minWidth: 200 }}>
						<Divider textAlign="center">Preview</Divider>
						<Box>
							{term?.name}
						</Box>
					</Stack> */}
				</Stack>
			</DialogContent>
			<DialogActions>
				<Stack direction="column">
					{term?.id == null && <FormControlLabel slotProps={{ typography: { fontSize: '85%' } }} control={<Checkbox checked={addMore} onChange={() => setAddMore(!addMore)} sx={{ p: 0, m: 0, mr: 1 }} size="small" />} label="Keep adding more" />}
					<Stack>
						<Button onClick={props.onCancel}>Cancel</Button>
						<Button color="primary" variant="contained" onClick={() => save()} disabled={!termSchema.isValidSync(term) || dialogs.isSaving?.term == true}>Save</Button>
					</Stack>
				</Stack>
				{/* <Box sx={{ mr: 10 }} />
				{term?.id != null && <Button color="error" variant="outlined" onClick={() => onDelete()}>Delete</Button>} */}
			</DialogActions>
		</Dialog>
	);
}
